var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('ArrowGame'),_vm._m(1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"visually-hidden"},[_c('h1',[_vm._v(" Dentsu Gaming | Gem Quest ")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',{staticClass:"powered-by-footer"},[_vm._v(" Powered by Merkle | a dentsu company ")])])
}]

export { render, staticRenderFns }